/** @jsxImportSource react */
import { Button } from '@react/system';
import { Arrow } from '@sly/icons/react';
import cx from 'classnames';

interface ReadMoreContainerProps {
  readMoreText: string;
  showArrow?: boolean;
  onClickHandler?: () => void;
  eventProps?: Record<string, any>;
  className?: string;
  removeTopMargin?: boolean;
  showArrowDirection?: boolean;
  direction?: 'up' | 'down';
  dataTestId?: string;
}

function ReadMoreContainer({
  readMoreText,
  showArrow,
  onClickHandler = () => 0,
  eventProps = {},
  className,
  removeTopMargin,
  showArrowDirection,
  direction,
  dataTestId,
}: ReadMoreContainerProps) {
  return (
    <Button
      className={cx(
        '!font-t-xs-azo inline-block w-fit cursor-pointer !p-0 text-viridian-base underline md:mt-0',
        className,
        !removeTopMargin && '!mt-l'
      )}
      onClick={onClickHandler}
      variant='custom'
      eventProps={{
        text: readMoreText,
        ...eventProps,
      }}
      aria-label={readMoreText}
      data-testid={dataTestId}
    >
      {readMoreText}
      {showArrow && <Arrow className='rotate-90' />}
      {showArrowDirection && (
        <Arrow
          className={cx(
            'pl-1',
            direction === 'down' ? 'rotate-90' : '-rotate-90'
          )}
        />
      )}
    </Button>
  );
}

export default ReadMoreContainer;
